// Add your custom JS here.

// counter function
document.addEventListener('DOMContentLoaded', function () {
  const statisticsSection = document.getElementById('num-counter');
  if (statisticsSection) {
    const counters = document.querySelectorAll('.counter');
    const counterObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            counters.forEach(counter => {
              const updateCounter = () => {
                const target = +counter.getAttribute('data-target');
                const count = +counter.innerText;
                const increment = target / 100; // Adjust the divisor for speed

                if (count < target) {
                  counter.innerText = Math.ceil(count + increment);
                  setTimeout(updateCounter, 50); // Adjust the speed here
                } else {
                  counter.innerText = target;
                }
              };
              updateCounter();
            });
            observer.unobserve(statisticsSection); // Stop observing once done
          }
        });
      },
      { threshold: 0.5 }
    );

    counterObserver.observe(statisticsSection);
  }
});

(function ($) {
  jQuery(document).ready(function ($) {
    // Testimonial Slider
    $('.testimonial-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: true,
      infinite: false,
      appendArrows: $('.testimonial .slick-arrows'),
      prevArrow:
        '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 11.375L12 7L4 12L12 17L12 12.625L20 12.625L20 11.375L12 11.375Z" fill="#292929"/></svg></button>',
      nextArrow:
        '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 11.375L12 7L20 12L12 17L12 12.625L4 12.625L4 11.375L12 11.375Z" fill="#292929"/></svg></button>',
      dots: false,
      responsive: [
        {
          breakpoint: 1480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    // Video Testimonial Slider
    $('.testimonial-video').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: true,
      infinite: false,
      appendArrows: $('.video-testimonial .slick-arrows'),
      prevArrow:
        '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 11.375L12 7L4 12L12 17L12 12.625L20 12.625L20 11.375L12 11.375Z" fill="#292929"/></svg></button>',
      nextArrow:
        '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 11.375L12 7L20 12L12 17L12 12.625L4 12.625L4 11.375L12 11.375Z" fill="#292929"/></svg></button>',
      dots: false,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    // how it works slider on mobile

    var $slider = $('.works--view');

    function initializeSlider() {
      if ($(window).width() < 575 && !$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 2000,
          arrows: true,
          infinite: false,
          appendArrows: $('.how-it-works .slick-arrows'),
          prevArrow:
            '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 11.375L12 7L4 12L12 17L12 12.625L20 12.625L20 11.375L12 11.375Z" fill="#292929"/></svg></button>',
          nextArrow:
            '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 11.375L12 7L20 12L12 17L12 12.625L4 12.625L4 11.375L12 11.375Z" fill="#292929"/></svg></button>',
          dots: false,
        });
      } else if (
        $(window).width() >= 575 &&
        $slider.hasClass('slick-initialized')
      ) {
        $slider.slick('unslick');
      }
    }

    // Initial check
    initializeSlider();

    // Check on resize
    $(window).resize(function () {
      initializeSlider();
    });

    // Price table for mobile

    var $slider = $('.mobile-slider-price');

    function initializeSliderPrice() {
      if ($(window).width() < 1200 && !$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 2000,
          arrows: true,
          infinite: false,
          appendArrows: $('.price-table .slick-arrows'),
          prevArrow:
            '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 11.375L12 7L4 12L12 17L12 12.625L20 12.625L20 11.375L12 11.375Z" fill="#292929"/></svg></button>',
          nextArrow:
            '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 11.375L12 7L20 12L12 17L12 12.625L4 12.625L4 11.375L12 11.375Z" fill="#292929"/></svg></button>',
          dots: false,
          responsive: [
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
          ],
        });
      } else if (
        $(window).width() >= 1200 &&
        $slider.hasClass('slick-initialized')
      ) {
        $slider.slick('unslick');
      }
    }

    // Initial check
    initializeSliderPrice();

    // Check on resize
    $(window).resize(function () {
      initializeSliderPrice();
    });

    // Lottie Animation

    var animationUrl = [
      {
        id: 'lottie',
        path:
          siteroot.root_url +
          '/wp-content/themes/brokergenius-understrap-child-theme/animation/main-comp-2.json',
      },
      {
        id: 'lottie2',
        path:
          siteroot.root_url +
          '/wp-content/themes/brokergenius-understrap-child-theme/animation/main-comp-2.json',
      },
    ];

    animationUrl.forEach(animation => {
      fetch(animation.path)
        .then(response => response.json())
        .then(data => {
          console.log(data);
          lottie.loadAnimation({
            container: document.getElementById(animation.id),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: data,
          });
        })
        .catch(error =>
          console.error('Error loading Lottie animation:', error)
        );
    });
  });

  // Blog post

  jQuery(document).ready(function ($) {
    var ajaxUrl = ajax_object.ajax_url;
    var page = 1;
    var category = 'all';
    var total_cat_posts = ajax_object.total_posts;

    let count;
    if (window.innerWidth < 768) {
      count = 4; // Fewer posts for small screens
    } else if (window.innerWidth < 1500) {
      count = 6; // Moderate number of posts for medium screens
    } else {
      count = 8; // More posts for larger screens
    }

    function loadPosts(data = total_cat_posts) {
      $.ajax({
        url: ajaxUrl,
        type: 'post',
        data: {
          action: 'load_posts',
          page: page,
          category: category,
          count: count,
        },
        success: function (response) {
          if (response) {
            //loadmore btn visibility
            if (data <= page * count) {
              $('.load-more-btn').hide();
            } else {
              $('.load-more-btn').show();
            }

            $('.posts-list').append(response);
            page++;
          }
        },
      });
    }

    // On Click

    $('.filter-btn').on('click', function () {
      $('.filter-btn').removeClass('active');
      $(this).addClass('active');

      category = $(this).data('category');
      total_cat_posts = $(this).data('cat-count');
      page = 1;

      $('.posts-list').html('');
      loadPosts(total_cat_posts);
    });

    // On Change

    $('.change--filter').on('change', function () {
      $('.change--filter').removeClass('active');
      $(this).addClass('active');

      category = $(this).val();
      total_cat_posts = $(this).find(':selected').data('cat-count');
      page = 1;

      $('.posts-list').html('');
      loadPosts(total_cat_posts);
    });

    $('.load-more-btn').on('click', function () {
      loadPosts();
    });

    // Initial load
    loadPosts();
  });

  //How to page function

  jQuery(document).ready(function ($) {
    // Initialize the Bootstrap scrollspy for the primary target
    var scrollSpyElement = $('.scrollspy-example');
    scrollSpyElement.scrollspy({
      target: '#list-example-mobile',
    });

    // Custom logic for the second target
    var desktopNav = $('#list-example-desktop');
    var mobileNavLinks = $('#list-example-mobile .list-group-item-action');
    var desktopNavLinks = $('#list-example-desktop .list-group-item-action');

    function updateDesktopNav(activeSectionId) {
      // Remove active class from all desktop nav links
      desktopNavLinks.removeClass('active');

      // Add active class to the corresponding desktop nav link
      desktopNav.find('a[href="' + activeSectionId + '"]').addClass('active');
    }

    // Listen for scroll events on the scrollspy element
    scrollSpyElement.on('activate.bs.scrollspy', function (event) {
      var activeSectionId = $(event.relatedTarget).attr('href');
      if (history.pushState) {
        history.pushState(null, null, activeSectionId);
      } else {
        location.hash = activeSectionId;
      }

      // Update the second (desktop) target's navigation
      updateDesktopNav(activeSectionId);
    });

    // Sync scrolling between mobile and desktop navs (optional)
    mobileNavLinks.on('click', function (e) {
      // e.preventDefault();

      var targetSection = $($(this).attr('href'));

      $('html, body').animate(
        {
          scrollTop: targetSection.offset().top,
        },
        500
      );

      // Sync desktop nav with the mobile nav click
      updateDesktopNav($(this).attr('href'));
    });

    desktopNavLinks.on('click', function (e) {
      // e.preventDefault();
      var targetSection = $($(this).attr('href'));

      $('html, body').animate(
        {
          scrollTop: targetSection.offset().top,
        },
        500
      );

      // Sync mobile nav with the desktop nav click
      scrollSpyElement.scrollTop(targetSection.position().top);
    });
  });

  // Quiz function
  jQuery(document).ready(function ($) {
    function getCookie(name) {
      let value = `; ${document.cookie}`;
      let parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }

    // Usage
    let myCookie = getCookie('quizClosed');
    if (!myCookie) {
      $('#staticBackdrop').modal('show');
    }

    $('.btn-close').click(function () {
      document.cookie = 'quizClosed=quizClosed; path=/';
    });
  });

  // price row height
})(jQuery);
